import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { t } from "i18next";

import { Icon } from "components";
import { getArtieLogo, getIsMaximized, getJaiEditUrl, selectIsJAI } from "slices";
import { renderMascot } from "utils";
import ExtraOption from "components/OptionsBox/ExtraOptions/index";

import { NeighborhoodMapView } from "./NeighborhoodMapView/index";

const Neighborhood = ({ isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, message, subject, summary, neighborhood = {} }) => {
  const artieLogo = useSelector(getArtieLogo);
  const jaiEditURL = useSelector(getJaiEditUrl);
  const isJAI = useSelector(selectIsJAI);
  const isMaximized = useSelector(getIsMaximized);
  const [data, setData] = useState([]);
  const [selectedView, setSelectedView] = useState("list");

  const formatNeighborhoodResponse = (message, isParsed = false) => {
    try {
      const data = isParsed ? message : JSON.parse(message);
      let result = [];

      for (let category in data) {
        if (Object.prototype.hasOwnProperty.call(data, category)) {
          let names = data[category].names;
          let distances = data[category].distances;
          let links = data[category].links;
          let lat_lngs = data[category].lat_long;

          let items = [];

          for (let i = 0; i < names.length; i++) {
            let name = names[i];
            let distance = distances[i];
            let link = links[i];
            let lat_lng = lat_lngs[i];
            let item = {
              name: name,
              category: category,
              distance: distance,
              link: link,
              lat_lng: lat_lng,
            };

            items.push(item);
          }

          let categoryObject = {
            category: category,
            items: items,
          };

          result.push(categoryObject);
        }
      }

      return result;
    } catch (err) {
      return [];
    }
  };

  useEffect(() => {
    if (subject === "neighborhood") {
      if (neighborhood && typeof neighborhood === "object" && Object.keys(neighborhood).length > 0) {
        const formattedData = formatNeighborhoodResponse(neighborhood, true);
        setData(formattedData);
      }
    } else if (subject === "neighborhood_summary") {
      const formattedData = formatNeighborhoodResponse(message);
      setData(formattedData);
    }
  }, [message, subject]);

  const extraButtons = isJAI
    ? [
        {
          text: t("editSubOrg"),
          handleClick: () => window.open(jaiEditURL, "_blank"),
        },
      ]
    : null;

  const getMessage = () => {
    if (subject === "neighborhood") {
      return message || "Sure thing! Here are the details";
    } else if (subject === "neighborhood_summary") {
      return summary;
    }

    return "";
  };

  return (
    <div style={{ overflowWrap: "break-word" }}>
      {subject && (
        <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
          {isUserMsg ? (
            isMaximized ? (
              <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
            ) : (
              ""
            )
          ) : (
            <>
              {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

              {!isEmpty(artieLogo) && (
                <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                  <img
                    id="staticImage"
                    src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                    alt=""
                    className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                  />
                </div>
              )}
            </>
          )}
          <div className="hayley-mx-3 hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
            {data.length > 0 && data[0]?.category ? getMessage() : summary || message}
          </div>
        </div>
      )}

      {!!data && data[0]?.category && (
        <div className={`hayley-w-full hayley-max-w-[725px] ${!isLastBot ? "hayley-mt-3" : ""}`}>
          <div className="hayley-mx-auto hayley-flex hayley-w-full hayley-max-w-[164px] hayley-justify-center hayley-rounded-[4px] hayley-bg-[#EEEEEE] hayley-p-[2px] ">
            <button
              className={`hayley-cursor-pointer hayley-rounded-[4px] hayley-border-none ${
                selectedView === "list" ? "hayley-bg-white hayley-font-semibold hayley-text-[#333333]" : "hayley-text-[#666666]"
              }  hayley-px-[13px] hayley-py-[4px] hayley-text-[12px] hayley-outline-none`}
              onClick={() => setSelectedView("list")}
            >
              List View
            </button>
            <button
              className={`hayley-cursor-pointer hayley-rounded-[4px] hayley-border-none ${
                selectedView === "map" ? "hayley-bg-white hayley-font-semibold hayley-text-[#333333]" : "hayley-text-[#666666]"
              }  hayley-px-[13px] hayley-py-[4px] hayley-text-[12px] hayley-outline-none`}
              onClick={() => setSelectedView("map")}
            >
              Map View
            </button>
          </div>
        </div>
      )}

      {!!data && data[0]?.category && selectedView === "list" ? (
        data.map((sin, idx) => (
          <div key={idx} className="hayley-mt-2 hayley-w-full hayley-max-w-[725px]">
            <h5 style={{ borderBottom: "1px solid #EEEEEE" }} className="hayley-my-0 hayley-p-2 hayley-font-semibold">
              {sin.category}
            </h5>
            <ul className="hayley-my-0 hayley-px-2">
              {sin.items?.map((item, index) => {
                return (
                  <li key={index} className="hayley-flex hayley-items-center hayley-justify-between">
                    <h5 className="hayley-my-2 hayley-flex-1 hayley-text-[14px] hayley-font-normal hayley-text-[#333333]">{item?.name}</h5>
                    <div className="hayley-flex hayley-items-center hayley-gap-x-3 hayley-pl-2">
                      <p className="hayley-my-0 hayley-flex-shrink-0 hayley-text-[14px] hayley-text-[#666666]">{item?.distance}</p>
                      {item?.link !== "--" && (
                        <a
                          href={item?.link}
                          target="_blank"
                          className="hayley-text-[14px] hayley-text-[#4F6FAE]"
                          style={{ textDecoration: "none" }}
                          rel="noreferrer"
                        >
                          <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width={20} height={20} rx={10} transform="matrix(-1 0 0 1 20 0)" fill="white" />
                            <path
                              d="M16 10.6001L5.97149 5.0287L8.20005 10.6001L5.97149 16.1715L16 10.6001Z"
                              stroke="#4F6FAE"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </a>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        ))
      ) : selectedView === "map" ? (
        <div className="max-w-[725px] hayley-mt-[12px] hayley-w-full">
          <NeighborhoodMapView data={data} />
        </div>
      ) : null}
      {isLastBot ? <ExtraOption from="neighborhood_summary" extraButtons={extraButtons} /> : null}
    </div>
  );
};

export default Neighborhood;
